export const setupProgress = {
  title: 'Setup your account',
  dismiss: 'Dismiss',
  percentComplete: '{{percent}}% complete',
  completed: 'completed',
  steps: {
    websites: {
      label: 'Websites',
      description: 'At least one website',
    },
    companyData: {
      label: 'Company',
      description: 'Industry & objectives',
    },
    brandIdentity: {
      label: 'Identity',
      description: 'Logo & colors',
    },
    brandVoice: {
      label: 'Brand Voice',
      description: 'At least one voice',
    },
  },
} as const
